module.exports = __webpack_public_path__ + "static/img/swiperadmin5.6bbdf99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/swiperadmin5.png
// module id = b4Qx
// module chunks = 1